import { useEffect, useState } from "react";

export default function useVisibleNodes({ nodes, rootMargin = "0px", threshold = 0 }) {
	const [aboveNodes, setAboveNodes] = useState([]);
	const [belowNodes, setBelowNodes] = useState([]);
	const [visibleNodes, setVisibleNodes] = useState([]);

	useEffect(() => {
		const above = [];
		const below = [];

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.boundingClientRect.top < 0 && !entry.isIntersecting) {
						if (!above.includes(entry.target)) {
							above.push(entry.target);
						}
						const belowIndex = below.indexOf(entry.target);
						if (belowIndex !== -1) {
							below.splice(belowIndex, 1);
						}
					} else if (entry.boundingClientRect.top > window.innerHeight && !entry.isIntersecting) {
						if (!below.includes(entry.target)) {
							below.push(entry.target);
						}
						const aboveIndex = above.indexOf(entry.target);
						if (aboveIndex !== -1) {
							above.splice(aboveIndex, 1);
						}
					} else {
						const aboveIndex = above.indexOf(entry.target);
						if (aboveIndex !== -1) {
							above.splice(aboveIndex, 1);
						}
						const belowIndex = below.indexOf(entry.target);
						if (belowIndex !== -1) {
							below.splice(belowIndex, 1);
						}
					}
				});

				setAboveNodes([...above]);
				setBelowNodes([...below]);
				setVisibleNodes(nodes.filter((node) => !above.includes(node) && !below.includes(node)));
			},
			{
				root: null,
				rootMargin,
				threshold,
			},
		);

		nodes.forEach((node) => {
			observer.observe(node);
		});

		return () => {
			nodes.forEach((node) => {
				observer.unobserve(node);
			});
		};
	}, [nodes, rootMargin, threshold]);

	return { aboveNodes, belowNodes, visibleNodes };
}
